let locales = {
    "formsList_": "",
};

export default locales;